import OFFER from 'constants/offer';

export const getCategoryGroupedByGroupName = (categories) => {
  const groupBy = (array, key) =>
    array.reduce((result, currentValue) => {
      const groupedByGroupName = result;

      (groupedByGroupName[currentValue[key]] =
        groupedByGroupName[currentValue[key]] || []).push(currentValue);

      return groupedByGroupName;
    }, {});

  return Object.entries(groupBy(categories, 'groupName')).map(
    ([key, value]) => ({
      categoryGroupName: key,
      categoryGroupId: value.flatMap((category) => [category.groupId])[0],
      categoriesWithSubcategories: value,
    })
  );
};

export const getDeepSubcategoryParent = (deepSubcategory) =>
  deepSubcategory?.category.subcategories.find(
    ({ deepSubcategories }) => deepSubcategories?.length > 0
  );

export const getOrderOffersGaEventAction = (sortValue) => {
  switch (sortValue) {
    case OFFER.SORT_VALUES.LATEST:
      return 'orderby_more_recent';
    case OFFER.SORT_VALUES.MOST_REACTED:
      return 'orderby_more_reaction';
    case OFFER.SORT_VALUES.MOST_COMMENTED:
      return 'orderby_more_comments';
    default:
      return null;
  }
};

export const isOffersFiltersActive = (offersFilters = null) => {
  if (!offersFilters) {
    return false;
  }

  const { priceRange, stores, venue } = offersFilters;

  return (
    priceRange.min > 0 || priceRange.max > 0 || stores.length > 0 || !!venue
  );
};

export const toHeadingTitle = (str) => `${str} em Promoção`;
